<template>
    <div v-show="customerData">
        <b-input-group prepend="Name:" class="my-3" size="lg">
            <b-input type="text" name="company name" v-model="customerData.name" @input="saveDebounce()" :disabled="!dataLoaded"></b-input>
        </b-input-group>

        <!-- Settings -->
        <b-input-group prepend="Homeschool State" class="mb-3">
            <b-select :options="homeschoolStateOptions" v-model="customerData.homeschool_state" @input="saveDebounce()" :disabled="!canModifyState || !dataLoaded"></b-select>
        </b-input-group>

        <CustomerUsers :customerId="customerId" v-if="customerId"/>
        <b-card class="mt-4">
            <template #header><h4>Orders</h4></template>
            <OrderCollection :orders="customerOrders" v-if="customerOrders.length"/>
        </b-card>
    </div>
</template>

<script>
import CustomerUsers from "@/components/dashboard/customers/CustomerUsers.vue";
import OrderCollection from "@/components/dashboard/OrderCollection.vue";
export default {
    name: "CustomerEdit",
    components: {OrderCollection, CustomerUsers},
    props: ['customerId'],
    data: () => ({
        customerData: {},
        customerOrders: [],
        saveDebounce: null,
        dataLoaded: false,

        // Form fields
        homeschoolStateOptions: [
            {value: null, text: 'None'},
            {value: 'CA', text: 'California'}
        ],
    }),
    watch: {
        customerId() {
            this.getCustomerData();
        }
    },
    computed: {
        canModifyState() {
            return this.$auth.check('admin');
        }
    },
    created() {
        this.saveDebounce = _.debounce(this.saveName, 500);
        this.getCustomerData();
    },
    methods: {
        saveName() {
            if (!this.dataLoaded) return;
            let data = {
                id: this.customerData.id,
                name: this.customerData.name,
                homeschool_state: this.customerData.homeschool_state,
            };
            this.axios.post('/dashboard/customer/' + this.customerId, data)
                .then((response) => {
                    this.$bvToast.toast("saved", {
                        variant: 'info',
                        solid: true,
                        noCloseButton: true,
                        autoHideDelay: 2000
                    });
                })
                .catch((e) => {
                    this.$bvToast.toast("something went wrong", {
                        variant: 'danger',
                        solid: true,
                        noCloseButton: true,
                        autoHideDelay: 2000
                    });
                })
        },
        getCustomerData() {
            this.dataLoaded = false;
            this.getOrdersForCustomer();
            this.customerData = {};
            this.axios.get('/dashboard/customer/' + this.customerId)
                .then((response) => {
                    this.customerData = response.data;
                    this.customerName = response.data.name;
                    setTimeout(() => { this.dataLoaded = true; }, 600);
                })
        },
        getOrdersForCustomer() {
            localStorage.setItem("customerId", this.customerId);
            this.$store.dispatch('getOrdersForCustomer', this.customerId)
                .then((response) => {
                    this.customerOrders = response.data;

                    for (let i = 0; i < this.customerOrders.length; ++i) {
                        let companyId = this.customerOrders[i].company_id;
                        if (!this.companyIds.hasOwnProperty(companyId))
                            this.companyIds[companyId] = [1];//this.orders[i]];
                        else
                            this.companyIds[companyId].push(1);//this.orders[i]);
                    }
                })
        }
    }
}
</script>

<style scoped>

</style>